<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Sales Commission"
            />
        </div>
        <div class="mt-2 px-2">
          <div class="row">
          <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
            <div class="mb-1">
              <label for="colFormLabel" class="col-form-label">Staff Id</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  placeholder="Enter Staff Id"
                  v-model="staffId"
              >
            </div>
          </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
              <div class="mb-1">
                <label for="colFormLabel" class="col-form-label">Month</label>
                <vField
                    v-model="month"
                    name="month"
                    id="month"
                    type="month"
                    class="form-control"
                />
              </div>
            </div>
          <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
            <button
                style="min-width: 64px;"
                @click="onClickToGo"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            > Go
            </button>
          </div>
        </div>
        </div>
      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="onClickToPrint"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
          >
            Print
          </button>
        </div>
      </div>

        <div class="col-md-4 col-12">
          <div class="card p-2">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-left">PARTICULARS</th>
                  <th class="text-right">Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>A. Personal Sales Commission</td>
                  <td class="text-right">{{ commaFormat(totalValue.personal_sales_commission) }}</td>
                </tr>
                <tr>
                  <td>B. Group Sales Commission</td>
                  <td class="text-right">{{ commaFormat(totalValue.total_group_commission_amount) }}</td>
                </tr>
                <tr>
                  <td>C. Company Sales Share</td>
                  <td class="text-right">{{ commaFormat(totalValue.total_company_sale_share) }}</td>
                </tr>
                <tr>
                  <td>D. BP Commission</td>
                  <td class="text-right">{{ commaFormat(totalValue.total_group_bp_commission_amount) }}</td>
                </tr>
                <tr>
                  <td class="text-bold">TOTAL COMMISSION</td>
                  <td class="text-right text-bold">{{ commaFormat(totalValue.total_commission) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-center">Staff ID</th>
                  <th class="text-center">Staff Name</th>
                  <th class="text-center">Designation</th>
                  <th class="text-center">Ref ID</th>
                  <th class="text-right">Allocated Sales Amount</th>
                  <th class="text-right">Qualified Rank</th>
                  <th class="text-center">Com %</th>
                  <th class="text-right">Sales Commission</th>
                  <th class="text-center">Generation</th>
                  <th class="text-center">BP Com %</th>
                  <th class="text-right">BP Commission Amount</th>
                </tr>
                </thead>
                <tbody ref="tableRef">
                <tr>
                  <td colspan="11"><strong>A. PERSONAL SALES COMMISSION</strong></td>
                </tr>
                <tr>
                  <td class="text-center">{{ personalSaleCommission.serial_no }}</td>
                  <td class="text-center">{{ personalSaleCommission.name }}</td>
                  <td class="text-center">{{ personalSaleCommission.level_name }} {{ personalSaleCommission.equivalent_designation ? '(' + personalSaleCommission.equivalent_designation + ')' : '' }}</td>
                  <td class="text-center">{{ personalSaleCommission.parent_serial_no }}</td>
                  <td class="text-right">{{ commaFormat(personalSaleCommission.allocated_sales_amount) }}</td>
                  <td class="text-center"> {{ personalSaleCommission.monthly_level_name }} {{ personalSaleCommission.monthly_equivalent_designation ? '(' + personalSaleCommission.monthly_equivalent_designation + ')' : '' }}</td>
                  <td class="text-center">{{ personalSaleCommission.sales_commission_percentage ?  + personalSaleCommission.sales_commission_percentage + '%' : '' }}</td>
                  <td class="text-right">{{ commaFormat(personalSaleCommission.sales_commission_amount) }} </td>
                  <td colspan="3" class="text-center">Not Applicable for Personal sales</td>
                </tr>

                <tr>
                  <td colspan="11"><strong>B. GROUP SALES COMMISSION</strong></td>
                </tr>
                <tr v-for="(item, i) in groupSaleCommissionData.data" :key="'group-' + i">
                  <td class="text-center">{{ item.serial_no || '' }}</td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ item.level_name }} ({{ item.equivalent_designation }})</td>
                  <td class="text-center">{{ item.parent_serial_no }}</td>
                  <td class="text-right">{{ commaFormat(item.allocated_sales_amount) }}</td>
                  <td class="text-center">
                    {{ item.monthly_level_name }} ({{ item.monthly_equivalent_designation }})
                    <span v-if="item.monthly_qualified === 'yes'" class="text-success">
                        <i class="fa fa-check"></i>
                    </span>
                    <span v-else class="text-danger">
                        <i class="fa fa-times"></i>
                   </span>
                  </td>
                  <td class="text-center">{{ item.group_sale_percentage }}% </td>
                  <td class="text-right">{{ commaFormat(item.group_commission_amount) }}</td>
                  <td class="text-center">{{ item.generation }}</td>
                  <td class="text-center">{{ item.bp_commission_percentage }}</td>
                  <td class="text-right">{{ commaFormat(item.bp_commission_amount) }}</td>
                </tr>

                <tr>
                  <td class="text-center" colspan="4">Total</td>
                  <td class="text-right">{{ commaFormat(totalValue.total_group_allocated_sales_amount) }}</td>
                  <td class="text-center" colspan="2"></td>
                  <td class="text-right">{{ commaFormat(totalValue.total_group_commission_amount) }}</td>
                  <td class="text-center" colspan="2"></td>
                  <td class="text-right">{{ commaFormat(totalValue.total_group_bp_commission_amount) }}</td>
                </tr>

                </tbody>
              </table>

              <p v-if="groupSaleCommissionData.data && groupSaleCommissionData.data.length < 0" class="text-center mt-5">No data</p>

              <div class="px-2 pt-2">
                <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
              </div>
            </div>
          </div>
        </div>

         <div class="col-12 col-12">
        <div class="card p-1">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th class="text-center">Level Qualified</th>
                <th class="text-center">Equivalent Designation</th>
                <th class="text-center">Company Sales Share %</th>
                <th class="text-right">Total Company Sales</th>
                <th class="text-right">Total Company Sales Share</th>
                <th class="text-center">Total Qualified Team This month</th>
                <th class="text-right">Company Sales Share Amount</th>
              </tr>
              </thead>
              <tbody ref="tableRef">
              <tr>
                <td colspan="7"><strong>C. COMPANY SALE SHARE</strong></td>
              </tr>
              <tr v-for="(item, i) in companySaleShareData" :key="i">
                <td class="text-center">{{ item.level_name }}</td>
                <td class="text-center">{{ item.equivalent_designation }}</td>
                <td class="text-center">{{ item.company_sale_share_percentage }}%</td>
                <td class="text-right">{{ commaFormat(item.total_company_sales) }}</td>
                <td class="text-right">{{ commaFormat(item.total_company_sale_share) }}</td>
                <td class="text-right">{{ item.total_qualified_member }}</td>
                <td class="text-right">{{ commaFormat(item.distributed_company_share_amount) }}</td>
              </tr>

              <tr>
                <td class="text-center" colspan="5">Total</td>
                <td class="text-right">{{ totalValue.total_qualified_member }}</td>
                <td class="text-right">{{ commaFormat(totalValue.total_company_sale_share) }}</td>
              </tr>

              </tbody>
            </table>
          </div>

        </div>
      </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import saleCommissionPdf from '@/services/utils/pdf/saleCommissionDataPdf';
import handleContact from '@/services/modules/contact'
import figureFormatter from "@/services/utils/figureFormatter";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const groupSaleCommissionData = ref([]);
const groupSaleCommissionPrintData = ref([]);
const companySaleShareData = ref([]);
const personalSaleCommission = ref({});
const staffId = ref(null);
const month = ref(null);
const totalValue = ref({});
const { fetchCompanyInfo } = handleCompany();
let companyInfo = reactive({})
const { exportToPDF } = saleCommissionPdf();
const { fetchContactProfiles } = handleContact()
let saveNewButtonLoader = ref(false)
const tableRef = ref(null)
const token = computed(() => localStorage.getItem('token'));
const { commaFormat, onlyCommaFormat } = figureFormatter();
const currentPage = ref(1)
const perPage = ref(100)
const {
  fetchSaleCommissionData
} = handleSdm()
let offset = ref(20)

const onClickToGo = () => {
  getSaleCommissionData();
}

async function onClickToPrint() {
  let query = getQuery();
  query += `&is_all=1`;
  companySaleShareData.value = []
  totalValue.value = {}
  personalSaleCommission.value = {}
  groupSaleCommissionPrintData.value = []

  await fetchSaleCommissionData(query).then((res) => {
    if (! res.status) {
      showError(res.message)
      return
    }
    let data = res.data;
    personalSaleCommission.value = data.personal_sale_commission;
    groupSaleCommissionPrintData.value = data.group_sale_commission;
    companySaleShareData.value = data.company_sale_share;
    totalValue.value = data.total;
  }).then(() => {
    exportToPDF(companyInfo, personalSaleCommission.value, groupSaleCommissionPrintData.value, companySaleShareData.value, totalValue.value, month.value)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getSaleCommissionData();
}

const getSaleCommissionData = async () => {
    const query = getQuery();
    loading.value = true
    companySaleShareData.value = []
    totalValue.value = {}
    personalSaleCommission.value = {}
    groupSaleCommissionData.value = []

    await fetchSaleCommissionData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        let data = res.data;

        personalSaleCommission.value = data.personal_sale_commission;
        groupSaleCommissionData.value = data.group_sale_commission;
        companySaleShareData.value = data.company_sale_share;
        totalValue.value = data.total;
        setPagination(data.group_sale_commission)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (staffId.value) query += '&staff_id=' + staffId.value;
    if (month.value) query += '&month=' + month.value;
    if (route.query.page) query += '&page=' + route.query.page;
    query += '&offset='+offset.value
    return query;
}

onMounted(() => {
  setCompanyInfo()
});

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>